import { render } from "./StockMovementReport.vue?vue&type=template&id=a98327be&scoped=true"
import script from "./StockMovementReport.vue?vue&type=script&lang=js"
export * from "./StockMovementReport.vue?vue&type=script&lang=js"

import "./inventoryReport.css?vue&type=style&index=0&id=a98327be&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98327be"]])

export default __exports__